/**
 * Tiny map-level loading indicator. Shown above the map (bottom-center)
 * during long operations like fetching 24K-point GeoJSON.
 *
 * Reference-counted: many callers can show their own message
 * concurrently; the bar stays up until the last one finishes.
 */
let depth = 0;

function el()    { return document.getElementById('mapLoading'); }
function msgEl() { return document.getElementById('mapLoadingMsg'); }

export function showMapLoading(message = 'Loading…') {
  depth += 1;
  if (msgEl()) msgEl().textContent = message;
  el()?.classList.add('show');
}

export function hideMapLoading() {
  depth = Math.max(0, depth - 1);
  if (depth === 0) el()?.classList.remove('show');
}

/** Wrap an async function so the indicator shows for its lifetime. */
export async function withMapLoading(message, fn) {
  showMapLoading(message);
  try { return await fn(); }
  finally { hideMapLoading(); }
}
